import type { SearchProvider } from '@atlaskit/editor-common/provider-factory';
import type { CloudId } from '@atlassian/jira-shared-types/src/general.tsx';
import { Scope } from '@atlassian/search-client';
import { createSearchProvider } from '@atlassian/search-provider';

export const useSearchProvider = (cloudId: CloudId): SearchProvider =>
	createSearchProvider(cloudId, Scope.JiraIssue);
